import * as t from "io-ts";
import { subcontractorsT as subcontractorsTI } from "dora-contracts";

export const subcontractorsT = subcontractorsTI;

export type Subcontractors = t.TypeOf<typeof subcontractorsTI>;
